import React, { createContext, useContext, useEffect, ReactNode } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../store/store';
import { fetchCurrencySettings } from '../store/slices/settingsSlice';
import { CurrencySettings } from '../services/settingsService';

interface SettingsContextType {
  currencySettings: CurrencySettings;
  loading: boolean;
  error: string | null;
}

const SettingsContext = createContext<SettingsContextType | undefined>(undefined);

interface SettingsProviderProps {
  children: ReactNode;
}

export const SettingsProvider: React.FC<SettingsProviderProps> = ({ children }) => {
  const dispatch = useDispatch();
  const { currencySettings, loading, error } = useSelector((state: RootState) => state.settings);

  useEffect(() => {
    // Load currency settings when the provider mounts
    dispatch(fetchCurrencySettings() as any);
  }, [dispatch]);

  const value: SettingsContextType = {
    currencySettings,
    loading,
    error,
  };

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = (): SettingsContextType => {
  const context = useContext(SettingsContext);
  if (context === undefined) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
};